// Italian

export default {
  component: {

    supportLink: 'support@recright.com',

    layout: {
      endTime: date => (date ? `attiva fino a ${date}` : ''),
    },
    interview: {
      title: 'Rispondi al video-colloquio',
      submit: 'Invia risposte e completa il colloquio',
      continueLater: 'Continua più tardi',
      startInterview: 'Inizia il colloquio',
      duplicateError: 'Hai già partecipato a questo colloquio. Hai ricevuto una email da invitations@recright.com contenente un link che può essere usato per continuare il colloquio.',
      confirmSubmitHeader: 'Non hai risposto a tutte le domande del colloquio',
      confirmSubmitContent: 'Vuoi davvero terminare il colloquio?',
      confirmSubmitContentWarning: 'Dopo di ciò, non potrai completare le tue risposte.',
      submitInterviewHeader: 'Invia le risposte al colloquio',
      submitInterviewContent: 'Vuoi davvero inviare le risposte al colloquio?',
      confirmSubmitButton: 'Invia risposte e completa il colloquio',
      preview: 'Qui puoi avere un anteprima delle video domande.',
      withdrawLink: 'Non ti interessa più questa posizione? Ritirati dal processo qui.',
    },

    personalInterview: {
      title: 'Select time for an appointment',
      description: [
        'You have been invited to an appointment.',
        'Please select a time slot that suits you best.',
      ],
      position: 'Position:',
      location: 'Location:',
      time: 'Time:',
      timezoneNotice: [
        'Please keep in mind that the times are shown in your timezone.',
        'Your timezone appears to be:',
        'The appointment timezone is:',
      ],
      success: {
        title: 'Thank you',
        description: 'You have successfully scheduled a meeting',
        linkDescription: [
          'You can add the calendar invitation to your own calendar below.',
          'Or you can copy the link to your calendar app:',
        ],
        link: 'Add the calendar invitation to your calendar',
      },
    },

    interviewForm: {
      name: 'Nome',
      email: 'Email',
      phone: 'Numero di telefono',
      city: 'Città',
      link: 'Link',
      legendBasicInfo: 'Informazioni di base',
      placeholderName: 'Inserisci il tuo nome',
      placeholderEmail: 'Inserisci la tua email',
      placeholderPhone: 'Inserisci il tuo numero di telefono',
      placeholderCity: 'Inserisci la città',
      placeholderLink: 'Aggiungi link, per esempio quello del tuo profilo LinkedIn.',
      legendAttachments: 'Allegati',
      legendAdditionalFields: 'Informazioni aggiuntive',
      required: 'Gli elementi contrassegnati con un * asterisco sono obbligatori.',
    },

    sequencedInterview: {
      networkTest: {
        audio: 'Audio',
        video: 'Video',
        yes: 'Sì',
        no: 'No',
        supported: 'Supportato',
        quality: 'Qualità',
        header: 'Test della connessione di rete e del dispositivo',
        description: 'Ora eseguiremo un test per assicurarci che la tua connessione di rete e l\'hardware necessario per il colloquio (videocamera e telefono) funzionino correttamente. Quando ti verrà richiesto, autorizza il test a usare sia la videocamera che il microfono e assicurati che l\'obiettivo della telecamera non sia coperto. Il test durerà all\'incirca 30 secondi. Ti consigliamo di parlare durante il test dell\'hardware.',
        inProgress: 'Test in corso...',
        networkTestResults: 'Risultati test di rete',
        qualityTestResults: 'Risultati test qualità',
        testPassedQuality: 'Test qualità superato',
        testFailedQuality: 'Test della qualità non superato',
        testPassedNetwork: 'Test di rete superato',
        testFailedNetwork: 'Test di rete fallito',
        startTest: 'Avvia il test',
        startInterview: 'Inizia il colloquio',
        testAgain: 'Ripeti il test',
        confirmWarning: 'Quando inizia il videocolloquio, visualizzi automaticamente la prima domanda, dopodiché accedi alla preparazione.',
        confirmTitle: 'Stai per iniziare il colloquio',
        confirmText: 'Hai poco tempo per prepararti a rispondere prima di ogni domanda. Dopo la preparazione, hai un tempo predefinito per rispondere alla domanda. Ricorda che, appena sei pronto/a, puoi inviare la tua risposta anche prima che il tempo predefinito sia terminato.',
        confirmText2: 'Dopo aver risposto, passerai alla domanda successiva fino al termine della serie',
        confirmText3:
          'Ricorda che dopo aver registrato la risposta a una domanda avrai a disposizione 30 secondi per ripetere la registrazione della risposta, se la ripetizione è consentita per la domanda in questione. Se non avvii la ripetizione della registrazione entro questo periodo di 30 secondi, la risposta attuale verrà automaticamente inviata e passerai alla domanda successiva.',
        goodLuck: 'Fai un bel respiro, andrà tutto bene. In bocca al lupo!',
        qualityRating: {
          excellent: 'Ottimo',
          good: 'Buono',
          fair: 'Sufficiente',
          poor: 'Scarso',
          bad: 'Pessimo',
        },
      },
      questionAnswerView: {
        title: title => `Rispondi al colloquio ${title}`,
        question: 'Domanda',
        submitAndNext: 'Invia e prosegui',
        submitSuccess: 'Video inviato!',
        skipText: 'Inizia a registrare',
        stop: 'Stop',
        submitAndFinish: 'Invia e termina il colloquio',
        retake: 'Effettua nuova registrazione',
        take: 'Registrazione',
        takesLeft: 'Registrazioni rimanenti',
        skipTextQuestion: 'Tutto pronto? Continua',
        retakeConfirmTitle: 'Vuoi davvero ripetere la registrazione della risposta a questa domanda?',
        retakeConfirmSubmit: 'Sì, inizia la ripetizione della registrazione',
        submitInfoForward: 'Invio automatico della tua risposta corrente e avanzamento tra',
        submitInfoForward2: 'secondi',
        nonAnswerableText: 'Questo messaggio non richiede risposta. Dopo questo messaggio, passerai direttamente alla domanda successiva.',
        nonAnswerableVideo: 'Questo video non richiede risposta. Dopo questo video, passerai direttamente alla domanda successiva.',
        answerTimeInfo: (answerMinutes, answerSeconds) =>
          `Hai a disposizione ${answerMinutes} minuti e ${answerSeconds} secondi per rispondere alla domanda.`,
      },
      publisher: {
        toNextQuestion: timer => `Passerai alla domanda successiva fra ${timer}`,
        recordingStarts: timer => `La registrazione inizierà fra ${timer}`,
      },
      errors: {
        tooManyConnections: 'La connessione è stata interrotta perché ne hai già una aperta in un\'altra scheda o finestra.',
        unsupportedBrowser: 'Purtroppo quest\'operazione non è supportata dal tuo browser. Usa un browser differente.',
        networkError: 'Nessuna connessione di rete.',
        reconnecting: 'La connessione si è interrotta. Tentativo di riconnessione in corso...',
        generalError: 'Qualcosa è andato storto. Aggiorna la pagina e riprova.',
        allowMediaDevicesError: 'L\'operazione non ha rilevato dispositivi in grado di generare media (videocamera o microfono). Assicurati di aver autorizzato l\'utilizzo di videocamera e microfono da parte del browser.',
        noAvailableDevicesError: 'Impossibile trovare videocamera o microfono.',
        initPublisherError: 'Operazione non riuscita a causa di un errore. Assicurati di aver consentito al browser di utilizzare la fotocamera e il microfono e che essi non siano utilizzati da un\'altra applicazione. Quindi riprova.',
      },
      browserInfo: {
        browserSupportTitle: 'Supporto browser',
        supportedBrowsers: 'Questo test e il colloquio supportano le versioni più recenti di Chrome, Firefox, Safari ed Edge.',
        mobileSupported: 'Browser supportati su dispositivo mobile',
        android: 'Android: Google Chrome (versione più recente), Firefox (versione più recente)',
        iOS: 'iOS: Safari (versione più recente)',
        latestVersion: 'Assicurati di utilizzare la versione più recente del browser. In questo modo, tutto funzionerà alla perfezione.',
        freezeInstruction: 'Se la registrazione del video non si avvia o la schermata di registrazione rimane nera, aggiorna la pagina.',
        unsupportedOnIos: 'Stai utilizzando un browser non supportato su iOS. Usa Safari.',
        ieUnsupported: 'Stai utilizzando Internet Explorer. Purtroppo, questo browser non è supportato da questo test e dai colloquio. Usa un browser differente.',
        qualityTestNotSupported: 'Purtroppo il test dell\'hardware non è supportato dal browser che stai utilizzando. Puoi proseguire il colloquio senza effettuare il test della qualità audio e video o, in alternativa, usare un browser differente.',
      },
      reconnectSuccess: 'Connessione ripristinata!',
      continue: 'Continua',
    },

    withdraw: {
      title: 'Non ti interessa più questa posizione?',
      description: 'Ritirati dal processo di reclutamento.',
      buttonText: 'Ritirati dal processo di reclutamento',
      thankYouTitle: 'Grazie!',
      thankYouText: 'Hai informato i reclutatori che non ti interessa più la posizione.',
      confirm: 'Vuoi davvero ritirarti dal processo di reclutamento? Dopo il ritiro non sarai più in grado di rispondere a questo o a qualsiasi altro colloquio relativo a questa posizione.',
    },
  },

  page: {
    embeddedProfileInterview: {
      submit: 'Invia',
      continue: 'Continua',
      supportCenter: 'Recright Help Center',
      thankYou:
        'Ti ringraziamo per la tua video-risposta! Ti contatteremo presto!',
    },

    supportLink: 'support@recright.com',

    finished: {
      title: 'Grazie per aver partecipato al colloquio!',
      reopenDescription: 'Non preoccuparti se hai chiuso questo colloquio per sbaglio. Puoi riaprirlo premendo il pulsante qui sotto!',
      reopenButtonText: 'Riapri colloquio',
      description1: 'Bene, hai risposto a tutte le domande e le tue risposte sono state inviate.',
      descriptionsupport: mailto => `Se hai chiuso questo colloquio per sbaglio, ti preghiamo di contattare il nostro servizio clienti all'indirizzo  ${mailto} e riapriremo il tuo colloquio.`,
      descriptionfeedback: 'La tua esperienza è importante per noi! Com\'è stato rispondere a un video-colloquio? Come miglioreresti il nostro servizio? Lascia qui il tuo feedback.',
      feedbackbutton: 'Lasciaci un feedback!',
      regularUrl: 'https://www.surveymonkey.com/r/B3ZCSWT',
      timedUrl: 'https://www.surveymonkey.com/r/MZMLPPT',
    },
    messages: {
      title: 'Messaggio personale',
    },

    closed: {
      title: 'Il colloquio è stato completato o è terminato',
      description: 'Il video-colloquio a cui sei stato invitato è già terminato oppure hai completato il tuo invio.',
      publicTitle: 'Interview has ended',
      publicDescription: 'The video interview has already ended.',
    },
    saved: {
      title: 'Il tuo video colloquio è stato salvato!',
      description: 'Quando desidererai continuare il video-colloquio, utilizza il link che hai ricevuto sulla tua email. Quando ritornerai, ritroverai le video-risposte già registrate! Buona fortuna nella tua ricerca di lavoro!',
      remember: 'Ricorda di inviare le risposte al recruiter dopo che avrai finito di rispondere al colloquio.',
      deleteHistory: 'Se stai sostenendo il video-colloquio da un computer pubblico, ti preghiamo di ricordare di cancellare la tua cronologia di navigazione. In questo modo il tuo colloquio sarà sicuro.',
    },
    unpublished: {
      title: 'Il colloquio non è ancora aperto',
      publishTime: publishTime => `Il colloquio aprirà alle ${publishTime}`,
    },
  },
}
